import { Grid, Typography } from "@material-ui/core";
import React from "react";

export const SimpleFooter = (): JSX.Element => {
  const currentYear = new Date().getFullYear();

  return (
    <Grid
      container={true}
      direction="column"
      spacing={8}
      style={{ marginBottom: "5.25rem", marginTop: "2rem" }}
    >
      <Grid item={true}>
        <Typography align="center" style={{ fontWeight: "bold" }}>
          ® {currentYear} ComparaOnline.com es una marca registrada de Compara Online S.A.
        </Typography>
      </Grid>
      <Grid item={true}>
        <Typography align="center">
          Avenida Andrés Bello N° 2687 piso 24 comuna de Las Condes
        </Typography>
      </Grid>
    </Grid>
  );
};
